import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const CustomUnsortedIcon = () => <ArrowUpwardIcon sx={{ fontSize: 'inherit', opacity: 0.3 }} />;

export default CustomUnsortedIcon;
